// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8bb8eea9","977":"6d6faf47"}[chunkId] + ".chunk.js";
};